import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { useLayoutEffect, useState } from 'react';

export const ThrottleButton = ({
  shouldThrottle,
  throttleTime,
  children,
  disabled,
  onClick,
  ...otherProps
}: { shouldThrottle: boolean; throttleTime: number } & LoadingButtonProps) => {
  const [timer, setTimer] = useState<number>(0);
  const handleThrottleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (timer > 0 || disabled) return;
    onClick(e);
  };

  useLayoutEffect(() => {
    if (shouldThrottle) {
      setTimer(throttleTime);
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) clearInterval(interval);
          return prev > 0 ? prev - 1 : 0;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [shouldThrottle, throttleTime]);

  return (
    <LoadingButton {...otherProps} disabled={timer > 0 || disabled} onClick={handleThrottleClick}>
      {timer > 0 ? timer : children}
    </LoadingButton>
  );
};
